// extracted by mini-css-extract-plugin
export default {"container":"GlobalPracticesUpload_container__im8ZA","item":"GlobalPracticesUpload_item__LhN4V","label":"GlobalPracticesUpload_label__ake40"};